module.exports = __webpack_public_path__ + "img/icon.16339b2f.svg";